import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight, Eye } from "lucide-react";
import { a, text } from "framer-motion/client";
import oloratintanegra from "../../oloratintanegra.png";
import libretaamarilla from "../../libretaamarilla.png";
import unapuertaverde from "../../unapuertaverde.png";
import elpañueloblanco from "../../elpañueloblanco.jpeg";
import lamparaazul from "../../lamparaazul.png";
import despistadahastaelcielo from "../../despistadahastaelcielo.png";
import estabaoscuro from "../../estabaoscuro.png";
import tierrayasfaltogris from "../../tierrayasfaltogris.png";
import vaporopaco from "../../vaporopaco.png";
import canela from "../../canela.png";
import mochilavioleta from "../../mochilavioleta.png";
import batarosa from "../../batarosa.png";
import blancoinsulso from "../../blancoinsulso.png";
import verdeintenso from "../../verdeintenso.png";
import piquislapollitaclara from "../../piquislapollitaclara.png";
import boqueterojo from "../../boqueterojo.png";
import pantostado from "../../pantostado.png";
import enlaautopistadelsol from "../../enlaautopistadelsol.png";
import botellaambar from "../../botellaambar.png";
import naveanaranjada from "../../naveanaranjada.png";
import tenisturquesa from "../../tenisturquesa.png";
import pijamacafeacuadros from "../../pijamacafeacuadros.png";
import sombreromoradodemago from "../../sombreromoradodemago.png";
import sala from "../../sala.png";
import estudio from "../../estudio.jpg";
import habitacion from "../../habitación.png";
// Datos para la galería contextual
const contextGallery = {
  artworks: [
    {
      id: 1,
      title: "PIJAMA CAFE A CUADROS",
      image: pijamacafeacuadros,
      artist: "ARTE OLIVIERI",
      technique: "Giclèe sobre papel de alta calidad",
      text: "Llegó a la orilla; sus ojos se hicieron redondos por lo que vio: un pijama a cuadros café y blanco caminando solo. Se había escapado del cuerpo de su dueño de piernas largas…",
      dimensions: "23 x 29 | 43 x 59 cm",
      price: "$1,140 | $1,670 MXN",
    },
    {
      id: 2,
      title: "OLOR A TINTA NEGRA",
      image: oloratintanegra,
      artist: "ARTE OLIVIERI",
      technique: "Giclèe sobre papel de alta calidad",
      text: "Prácticamente todo el cuerpo le pica de forma desesperante, pero no se puede mover para rascarse. Frente a sus ojos y en cuestión de segundos, la piel se seca completamente…",
      dimensions: "23 x 29 | 43 x 59 cm",
      price: "$1,140 | $1,670 MXN",
    },
    {
      id: 3,
      title: "LIBRETA AMARILLA",
      image: libretaamarilla,
      artist: "ARTE OLIVIERI",
      technique: "Giclèe sobre papel de alta calidad",
      text: "Sus exposiciones eran sorprendentes; el color azul de la tinta que usaba caracterizaba su estilo. La gente podía pasar horas contemplando paredes repletas de creatividad pura…",
      dimensions: "23 x 29 | 43 x 59 cm",
      price: "$1,140 | $1,670 MXN",
    },
    {
      id: 4,
      title: "UNA PUERTA VERDE",
      image: unapuertaverde,
      text: "Quiero regresar a mi habitación, al olor a sábanas limpias, pero al dar la vuelta noto que ha desaparecido la puerta verde por la que entré hace un instante…",
      artist: "ARTE OLIVIERI",
      technique: "Giclèe sobre papel de alta calidad",
      dimensions: "23 x 29 | 43 x 59 cm",
      price: "$1,140 | $1,670 MXN",
    },
    {
      id: 5,
      title: "EL PAÑUELO BLANCO",
      image: elpañueloblanco,
      artist: "ARTE OLIVIERI",
      technique: "Giclèe sobre papel de alta calidad",
      text: "Esa fue la primera vez que mi abuela vio con sus propios ojos a una bestia pequeña, ¡pero bestia! entrar en el cuerpo de una persona…",
      dimensions: "23 x 29 | 43 x 59 cm",
      price: "$1,140 | $1,670 MXN",
    },
    {
      id: 6,
      title: "LÁMPARA AZUL",
      image: lamparaazul,
      artist: "ARTE OLIVIERI",
      technique: "Giclèe sobre papel de alta calidad",
      text: "Desaparece la tridimensión, no hay contrastes, siente que las paredes la ahogan. La habitación está vacía, sin ventanas ni puerta, apenas con el aire suficiente para respirar… ",
      dimensions: "23 x 29 | 43 x 59 cm",
      price: "$1,140 | $1,670 MXN",
    },
    {
      id: 7,
      title: "DESPISTADA HASTA EL CIELO",
      image: despistadahastaelcielo,
      artist: "ARTE OLIVIERI",
      technique: "Giclèe sobre papel de alta calidad",
      text: "Regreso por el mismo camino y por arte de magia vuelve la memoria, pareciera que un hada me dice al oído lo que había olvidado.",
      dimensions: "23 x 29 | 43 x 59 cm",
      price: "$1,140 | $1,670 MXN",
    },
    {
      id: 8,
      title: "ESTABA OSCURO",
      image: estabaoscuro,
      artist: "ARTE OLIVIERI",
      technique: "Giclèe sobre papel de alta calidad",
      text: "De pronto, una de las estrellas pareció desprenderse… “una estrella fugaz”, pensé. No le quité el ojo de encima, noté que desaceleró su caída y casi flotando aterrizó a mi lado…  ",
      dimensions: "23 x 29 | 43 x 59 cm",
      price: "$1,140 | $1,670 MXN",
    },
    {
      id: 9,
      title: "TIERRA Y ASFALTO GRIS",
      image: tierrayasfaltogris,
      artist: "ARTE OLIVIERI",
      technique: "Giclèe sobre papel de alta calidad",
      text: "Por primera vez conoció el asfalto gris y las construcciones de más de dos pisos y, entre camiones gigantescos y mucha gente, logró llegar…",
      dimensions: "23 x 29 | 43 x 59 cm",
      price: "$1,140 | $1,670 MXN",
    },
    {
      id: 10,
      title: "VAPOR OPACO",
      image: vaporopaco,
      artist: "ARTE OLIVIERI",
      technique: "Giclèe sobre papel de alta calidad",
      text: "Apenas abrió una rendija, una fuerza entró y revolvió su pelo. Una nube de vapor se sentó en su sala…",
      dimensions: "23 x 29 | 43 x 59 cm",
      price: "$1,140 | $1,670 MXN",
    },
    {
      id: 11,
      title: "CANELA",
      image: canela,
      artist: "ARTE OLIVIERI",
      technique: "Giclèe sobre papel de alta calidad",
      text: "De pronto tocan a la puerta, tac tac tac. Con esfuerzo se desprende de su comodidad, abre, y la sorprende lo inesperado: un perro pequeño color canela con pelo achinado… ",
      dimensions: "23 x 29 | 43 x 59 cm",
      price: "$1,140 | $1,670 MXN",
    },
    {
      id: 12,
      title: "MOCHILAVIOLETA",
      image: mochilavioleta,
      artist: "ARTE OLIVIERI",
      technique: "Giclèe sobre papel de alta calidad",
      text: "Su amistad empezó desde la primera semana en que sus máquinas de coser quedaron una junto a la otra. Las interrumpe la voz de Don Antonio…",
      dimensions: "23 x 29 | 43 x 59 cm",
      price: "$1,140 | $1,670 MXN",
    },
    {
      id: 13,
      title: "BATA ROSA",
      image: batarosa,
      artist: "ARTE OLIVIERI",
      technique: "Giclèe sobre papel de alta calidad",
      text: "La melodía la relaja, se deja llevar por sus sentidos, disfruta su trabajo. A los pies de la camilla aparece un hombre con sombrero.",
      dimensions: "23 x 29 | 43 x 59 cm",
      price: "$1,140 | $1,670 MXN",
    },
    {
      id: 14,
      title: "BLANCO INSULSO",
      image: blancoinsulso,
      artist: "ARTE OLIVIERI",
      technique: "Giclèe sobre papel de alta calidad",
      text: "Observo que los recuerdos son zurcidos de realidad e imaginación, me conformo con los hilachos que me quedan de él, y son río…",
      dimensions: "23 x 29 | 43 x 59 cm",
      price: "$1,140 | $1,670 MXN",
    },
    {
      id: 15,
      title: "VERDE INTENSO",
      image: verdeintenso,
      artist: "ARTE OLIVIERI",
      technique: "Giclèe sobre papel de alta calidad",
      text: "Me quedé fascinado leyendo y tratando de entender lo que, aunque complicado, era muy interesante. Tal vez la vida supo hacerme llegar ese mensaje para revelar mi camino…",
      dimensions: "23 x 29 | 43 x 59 cm",
      price: "$1,140 | $1,670 MXN",
    },
    {
      id: 16,
      title: "PIQUIS LA POLLITA CLARA",
      image: piquislapollitaclara,
      artist: "ARTE OLIVIERI",
      technique: "Giclèe sobre papel de alta calidad",
      text: "Fue de tantas patadas que inició su amor por el vuelo, sentirse suspendida en los aires se convirtió en su pasión, y así nacieron sus ganas de infinito.",
      dimensions: "23 x 29 | 43 x 59 cm",
      price: "$1,140 | $1,670 MXN",
    },
    {
      id: 17,
      title: "BOQUETE ROJO",
      image: boqueterojo,
      artist: "ARTE OLIVIERI",
      technique: "Giclèe sobre papel de alta calidad",
      text: "Una herida al rojo vivo, pero sin dolor. Lo más raro es que no estoy asustada…",
      dimensions: "23 x 29 | 43 x 59 cm",
      price: "$1,140 | $1,670 MXN",
    },
    {
      id: 18,
      title: "PAN TOSTADO",
      image: pantostado,
      artist: "ARTE OLIVIERI",
      technique: "Giclèe sobre papel de alta calidad",
      text: "Antes de levantar el otro pie para ponerse el calzado, algo le pasa. Siente un mareo y una fuerza turbulenta que lo arrancan de su cama.",
      dimensions: "23 x 29 | 43 x 59 cm",
      price: "$1,140 | $1,670 MXN",
    },
    {
      id: 19,
      title: "EN LA AUTOPISTA DEL SOL",
      image: enlaautopistadelsol,
      artist: "ARTE OLIVIERI",
      technique: "Giclèe sobre papel de alta calidad",
      text: "De pronto Rodri, con su voz de niño, mencionó una frase que provocó que algo ocurriera, no lo olvidaré nunca: “Ahí está la luz”. En ese segundo cambió el orden natural de las cosas…",
      dimensions: "23 x 29 | 43 x 59 cm",
      price: "$1,140 | $1,670 MXN",
    },
    {
      id: 20,
      title: "BOTELLA AMBAR",
      image: botellaambar,
      artist: "ARTE OLIVIERI",
      technique: "Giclèe sobre papel de alta calidad",
      text: "Con la juventud empujando sus decisiones, las fiestas eran cada vez más largas y llenas de excesos.",
      dimensions: "23 x 29 | 43 x 59 cm",
      price: "$1,140 | $1,670 MXN",
    },
    {
      id: 21,
      title: "NAVE ANARANJADA",
      image: naveanaranjada,
      artist: "ARTE OLIVIERI",
      technique: "Giclèe sobre papel de alta calidad",
      text: "Despacito se abrieron las compuertas, el sonido de la presión que escapó de la nave me hizo voltear de inmediato.",
      dimensions: "23 x 29 | 43 x 59 cm",
      price: "$1,140 | $1,670 MXN",
    },
    {
      id: 22,
      title: "TENIS TURQUESA",
      image: tenisturquesa,
      artist: "ARTE OLIVIERI",
      technique: "Giclèe sobre papel de alta calidad",
      text: "Algo llama su atención: en algunos de esos cables cuelgan zapatos, los ha visto desde niño, no entiende quién podría hacer eso.",
      dimensions: "23 x 29 | 43 x 59 cm",
      price: "$1,140 | $1,670 MXN",
    },
    {
      id: 23,
      title: "SOMBRERO MORADO DE MAGO ",
      image: sombreromoradodemago,
      artist: "ARTE OLIVIERI",
      technique: "Giclèe sobre papel de alta calidad",
      text: "La boda obviamente también fue de cuento, y los tres cerditos fueron los padrinos de honor.",
      dimensions: "23 x 29 | 43 x 59 cm",
      price: "$1,140 | $1,670 MXN",
    },
  ],

  spaces: [
    {
      id: "Habitación",
      name: "Habitación",
      image: habitacion,
      description:
        "Un espacio acogedor con luz natural, ideal para obras que aporten calidez y personalidad.",
      scale: 1,
      objectPosition: "center top",
      artPosition: {
        top: "4%",
        left: "41%",
        width: "35%",
        height: "35%",
        transform: "translate(-50%, 0)",
      },
    },
    {
      id: "minimal-office",
      name: "Sala",
      image: sala,
      description:
        "Un entorno de trabajo moderno donde las obras aportan color y estimulan la creatividad.",
      scale: 2,
      objectPosition: "center top",
      artPosition: {
        top: "0%",
        left: "65%",
        width: "20%",
        height: "40%",
        transform: "translate(-50%, 0)",
      },
    },
    {
      id: "estudio",
      name: "Estudio",
      image: estudio,
      description:
        "Ambiente vibrante donde las obras captan la atención de los visitantes.",
      scale: 1,
      objectPosition: "center center",
      artPosition: {
        top: "3%",
        left: "36%",
        width: "25%",
        height: "45%",
        transform: "translate(0, 0)",
      },
    },
  ],
};

const ContextGallery = () => {
  // helper: derive base filename from an imported asset URL
  const getBaseName = (url) => {
    if (!url || typeof url !== "string") return null;
    // try to match something like 'pijamacafeacuadros.abc123.png' or 'pijamacafeacuadros.png'
    const m = url.match(/([^\/]+?)(?:\.[0-9a-f]{6,})?\.(png|jpe?g|webp|jpg)$/i);
    if (m) return m[1];
    return null;
  };

  const buildSrcSet = (url, ext = "webp") => {
    const base = getBaseName(url);
    if (!base) return null;
    const sizes = [480, 800, 1200];
    return sizes.map((s) => `/resized/${base}-${s}.${ext} ${s}w`).join(", ");
  };

  const [currentArtworkIndex, setCurrentArtworkIndex] = useState(0);
  const [currentSpaceIndex, setCurrentSpaceIndex] = useState(0);
  const [isChanging, setIsChanging] = useState(false);

  const currentArtwork = contextGallery.artworks[currentArtworkIndex];
  const currentSpace = contextGallery.spaces[currentSpaceIndex];

  useEffect(() => {
    // Pequeña animación al cambiar imágenes
    if (isChanging) {
      const timer = setTimeout(() => {
        setIsChanging(false);
      }, 180); // reducir el tiempo para transiciones más rápidas
      return () => clearTimeout(timer);
    }
  }, [isChanging]);

  // Pre-cargar imágenes (artworks y espacios) para que los cambios sean instantáneos
  useEffect(() => {
    // Preload only the current artwork + its neighbors (prev/next) and the current space
    // Use Image.decode() when available to avoid blocking the main thread synchronously
    try {
      const len = contextGallery.artworks.length;
      const prev =
        currentArtworkIndex === 0 ? len - 1 : currentArtworkIndex - 1;
      const next =
        currentArtworkIndex === len - 1 ? 0 : currentArtworkIndex + 1;
      [currentArtworkIndex, prev, next].forEach((i) => {
        const src = contextGallery.artworks[i]?.image;
        if (!src) return;
        const img = new Image();
        img.src = src;
        if (img.decode) {
          img.decode().catch(() => {});
        }
      });

      // Preload current space background
      const sImg = new Image();
      sImg.src = currentSpace.image;
      if (sImg.decode) sImg.decode().catch(() => {});
    } catch (err) {
      // silent fallback if any src is invalid
    }
  }, [currentArtworkIndex, currentSpaceIndex]);

  const nextArtwork = () => {
    setIsChanging(true);
    setCurrentArtworkIndex((prev) =>
      prev === contextGallery.artworks.length - 1 ? 0 : prev + 1
    );
  };

  const prevArtwork = () => {
    setIsChanging(true);
    setCurrentArtworkIndex((prev) =>
      prev === 0 ? contextGallery.artworks.length - 1 : prev - 1
    );
  };

  const nextSpace = () => {
    setIsChanging(true);
    setCurrentSpaceIndex((prev) =>
      prev === contextGallery.spaces.length - 1 ? 0 : prev + 1
    );
  };

  const prevSpace = () => {
    setIsChanging(true);
    setCurrentSpaceIndex((prev) =>
      prev === 0 ? contextGallery.spaces.length - 1 : prev - 1
    );
  };

  // Variantes para animaciones
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        when: "beforeChildren",
        staggerChildren: 0.12,
        duration: 0.35,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.28 },
    },
  };

  const imageVariants = {
    hidden: { opacity: 0, scale: 0.95 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.18 },
    },
    exit: {
      opacity: 0,
      scale: 0.95,
      transition: { duration: 0.14 },
    },
  };

  return (
    <section
      id="gallery"
      className="py-20 bg-primary-darker relative overflow-hidden"
    >
      <motion.div
        className="container mx-auto px-4"
        variants={containerVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
      >
        <motion.div
          className="text-center max-w-3xl mx-auto mb-16"
          variants={itemVariants}
        >
          <span className="inline-block px-4 py-1 bg-accent bg-opacity-20 rounded-full text-accent text-sm font-medium mb-4">
            Ve tu arte, giclée, en espacios reales.{" "}
          </span>
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-accent-light">
            ENTRE HISTORIAS Y ARTE
          </h2>
          <p className="text-lg text-accent-light text-opacity-80">
            Son obras inspiradas en los relatos de mi libro “Veintitrés hilos”
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-center">
          <div className="lg:col-span-3">
            <motion.div
              className="rounded-2xl overflow-hidden  relative"
              variants={itemVariants}
            >
              {/* Espacio */}
              <div className="relative w-full aspect-[4/3]">
                <img
                  src={currentSpace.image}
                  alt={currentSpace.name}
                  className="w-full h-full object-cover"
                />

                {/* Obra de arte superpuesta */}
                <AnimatePresence mode="wait">
                  <motion.div
                    key={`${currentArtworkIndex}-${currentSpaceIndex}`}
                    className="absolute"
                    style={{
                      top: currentSpace.artPosition.top,
                      left: currentSpace.artPosition.left,
                      width: currentSpace.artPosition.width,
                      height: currentSpace.artPosition.height,
                      transform: currentSpace.artPosition.transform,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: "4px",
                      maxWidth: "95%",
                      maxHeight: "95%",
                    }}
                    variants={imageVariants}
                    initial="hidden"
                    animate={isChanging ? "exit" : "visible"}
                    exit="exit"
                  >
                    <picture className="w-full h-full ">
                      {(() => {
                        const webpSrcSet = buildSrcSet(
                          currentArtwork.image,
                          "webp"
                        );
                        const jpgSrc = (() => {
                          const base = getBaseName(currentArtwork.image);
                          return base
                            ? `/resized/${base}-800.jpg`
                            : currentArtwork.image;
                        })();
                        return (
                          <>
                            {webpSrcSet && (
                              <source
                                type="image/webp"
                                srcSet={webpSrcSet}
                                sizes="(max-width: 640px) 80vw, (max-width: 1024px) 60vw, 40vw"
                              />
                            )}
                            <img
                              src={jpgSrc}
                              alt={currentArtwork.title}
                              loading="eager"
                              decoding="async"
                              style={{
                                width: "auto",
                                height: "100%",
                                objectFit: "contain",
                                display: "block",
                              }}
                            />
                          </>
                        );
                      })()}
                    </picture>
                  </motion.div>
                </AnimatePresence>

                {/* Controles del espacio */}
                <div className="absolute inset-x-0 bottom-4 flex justify-center space-x-4">
                  <motion.button
                    className="p-2 rounded-full bg-primary-dark bg-opacity-70 text-accent-light hover:bg-opacity-90 transition-colors duration-300"
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                    onClick={prevSpace}
                  >
                    <ChevronLeft className="w-6 h-6" />
                  </motion.button>

                  <div className="py-2 px-4 rounded-full bg-primary-dark bg-opacity-70 text-accent-light text-sm">
                    {currentSpaceIndex + 1}/{contextGallery.spaces.length}:{" "}
                    {currentSpace.name}
                  </div>

                  <motion.button
                    className="p-2 rounded-full bg-primary-dark bg-opacity-70 text-accent-light hover:bg-opacity-90 transition-colors duration-300"
                    whileHover={{ scale: 1.1 }}
                    whileTap={{ scale: 0.9 }}
                    onClick={nextSpace}
                  >
                    <ChevronRight className="w-6 h-6" />
                  </motion.button>
                </div>
              </div>
            </motion.div>

            {/* Descripción del espacio */}
            <motion.div
              className="mt-4 text-accent-light text-opacity-80 text-center"
              variants={itemVariants}
            >
              {currentSpace.description}
            </motion.div>

            {/* Miniaturas de espacios */}
            <motion.div
              className="mt-8 grid grid-cols-6 gap-2"
              variants={itemVariants}
            >
              {contextGallery.spaces.map((space, index) => (
                <div
                  key={space.id}
                  className={`rounded-lg overflow-hidden cursor-pointer transition-all duration-300 ${
                    currentSpaceIndex === index
                      ? "ring-2 ring-accent ring-offset-2 ring-offset-primary-darker"
                      : "opacity-60 hover:opacity-100"
                  }`}
                  onClick={() => {
                    setIsChanging(true);
                    setCurrentSpaceIndex(index);
                  }}
                >
                  <picture>
                    {(() => {
                      const webpSet = buildSrcSet(space.image, "webp");
                      const jpgFallback = (() => {
                        const b = getBaseName(space.image);
                        return b ? `/resized/${b}-480.jpg` : space.image;
                      })();
                      return (
                        <>
                          {webpSet && (
                            <source
                              type="image/webp"
                              srcSet={webpSet}
                              sizes="64px"
                            />
                          )}
                          <img
                            src={jpgFallback}
                            alt={space.name}
                            loading="lazy"
                            decoding="async"
                            className="w-full h-16 object-cover"
                          />
                        </>
                      );
                    })()}
                  </picture>
                </div>
              ))}
            </motion.div>
          </div>

          <motion.div className="lg:col-span-2" variants={itemVariants}>
            <div className="bg-primary-light p-8 rounded-2xl border border-accent border-opacity-20 h-full">
              {/* Detalles de la obra */}
              <div className="flex flex-col h-full">
                <div className="flex items-center justify-between mb-6">
                  <h3 className="text-2xl font-bold text-accent-light">
                    Obra Seleccionada
                  </h3>
                  <div className="flex space-x-2">
                    <motion.button
                      className="p-1 rounded-full bg-primary-dark bg-opacity-30 text-accent-light hover:bg-opacity-50 transition-colors duration-300"
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.9 }}
                      onClick={prevArtwork}
                    >
                      <ChevronLeft className="w-5 h-5" />
                    </motion.button>

                    <motion.button
                      className="p-1 rounded-full bg-primary-dark bg-opacity-30 text-accent-light hover:bg-opacity-50 transition-colors duration-300"
                      whileHover={{ scale: 1.1 }}
                      whileTap={{ scale: 0.9 }}
                      onClick={nextArtwork}
                    >
                      <ChevronRight className="w-5 h-5" />
                    </motion.button>
                  </div>
                </div>

                <div className="mb-6">
                  <div className="rounded-lg overflow-hidden mb-4 md:h-64">
                    <AnimatePresence mode="wait">
                      <motion.div
                        key={currentArtworkIndex}
                        variants={imageVariants}
                        initial="hidden"
                        animate={isChanging ? "exit" : "visible"}
                        exit="exit"
                      >
                        <picture>
                          {(() => {
                            const webpSet = buildSrcSet(
                              currentArtwork.image,
                              "webp"
                            );
                            const jpgFallback = (() => {
                              const b = getBaseName(currentArtwork.image);
                              return b
                                ? `/resized/${b}-800.jpg`
                                : currentArtwork.image;
                            })();
                            return (
                              <>
                                {webpSet && (
                                  <source
                                    type="image/webp"
                                    srcSet={webpSet}
                                    sizes="(max-width: 640px) 90vw, (max-width: 1024px) 60vw, 40vw"
                                  />
                                )}
                                <img
                                  src={jpgFallback}
                                  alt={currentArtwork.title}
                                  loading="eager"
                                  decoding="async"
                                  className="w-full md:h-64 md:object-cover h-auto object-contain"
                                />
                              </>
                            );
                          })()}
                        </picture>
                      </motion.div>
                    </AnimatePresence>
                  </div>

                  <AnimatePresence mode="wait">
                    <motion.div
                      key={currentArtworkIndex}
                      variants={imageVariants}
                      initial="hidden"
                      animate={isChanging ? "exit" : "visible"}
                      exit="exit"
                    >
                      <h4 className="text-xl font-bold text-accent-light mb-2">
                        {currentArtwork.title}
                      </h4>
                      <p className="text-accent text-sm mb-4">
                        por {currentArtwork.artist}
                      </p>

                      {currentArtwork.text && (
                        <p className="text-accent-light text-opacity-80 mb-4 text-sm italic">
                          "{currentArtwork.text}"
                        </p>
                      )}

                      <div className="space-y-2 mb-6">
                        <div className="flex justify-between">
                          <span className="text-accent-light text-opacity-70">
                            Técnica:
                          </span>
                          <span className="text-accent-light">
                            {currentArtwork.technique}
                          </span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-accent-light text-opacity-70">
                            Dimensiones:
                          </span>
                          <span className="text-accent-light">
                            {currentArtwork.dimensions}
                          </span>
                        </div>
                        <div className="flex justify-between">
                          <span className="text-accent-light text-opacity-70">
                            Precio:
                          </span>
                          <span className="text-accent-light font-bold">
                            {currentArtwork.price}
                          </span>
                        </div>
                      </div>
                    </motion.div>
                  </AnimatePresence>
                </div>

                {/* Miniaturas de obras */}
                <div className="grid grid-cols-5 gap-2 mb-8">
                  {contextGallery.artworks.map((artwork, index) => (
                    <div
                      key={artwork.id}
                      className={`rounded-lg overflow-hidden cursor-pointer transition-all duration-300 ${
                        currentArtworkIndex === index
                          ? "ring-2 ring-accent"
                          : "opacity-60 hover:opacity-100"
                      }`}
                      onClick={() => {
                        setIsChanging(true);
                        setCurrentArtworkIndex(index);
                      }}
                    >
                      <picture>
                        {(() => {
                          const webpSet = buildSrcSet(artwork.image, "webp");
                          const jpgFallback = (() => {
                            const b = getBaseName(artwork.image);
                            return b ? `/resized/${b}-480.jpg` : artwork.image;
                          })();
                          return (
                            <>
                              {webpSet && (
                                <source
                                  type="image/webp"
                                  srcSet={webpSet}
                                  sizes="48px"
                                />
                              )}
                              <img
                                src={jpgFallback}
                                alt={artwork.title}
                                loading="lazy"
                                decoding="async"
                                className="w-full h-12 object-cover"
                              />
                            </>
                          );
                        })()}
                      </picture>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </motion.div>

      {/* Background decorative elements */}
      <motion.div
        className="absolute top-40 -left-20 w-96 h-96 rounded-full bg-accent opacity-5 blur-3xl"
        animate={{
          scale: [1, 1.3, 1],
          opacity: [0.05, 0.07, 0.05],
        }}
        transition={{
          duration: 15,
          repeat: Infinity,
          repeatType: "reverse",
        }}
      />
    </section>
  );
};

export default ContextGallery;